import { Column, Employee } from "src/api/types";

export const columns: readonly Column<Employee>[] = [
  {
    id: "employee",
    label: "Employee",
    minWidth: 100,
    align: "center",
    orderable: false,
    format: (row) => `${row.first_name} ${row.last_name}`,
  },
  {
    id: "email",
    label: "Email",
    minWidth: 70,
    align: "center",
    orderable: false,
    format: (row) => row.email,
  },
  {
    id: "roles",
    label: "Roles",
    minWidth: 100,
    align: "center",
    orderable: false,
    format: (row) =>
      row.roles
        .map((r) => (r.display_name != null ? r.display_name : r.name))
        .join(", "),
  },
];
